export default __webpack_public_path__ + "static/media/gallery_07.154f5d1c.jpg";